
import { Component, Vue } from 'vue-property-decorator';

import Form11ProcessHeader from "@/components/process/Form11/components/Form11ProcessHeader.vue";
import Form11CaseInformation from "@/components/process/Form11/components/Form11CaseInformation.vue";
import { form11StatusInfoType } from '@/types/Information/Form11';

@Component({
    components:{
        Form11ProcessHeader,
        Form11CaseInformation
    }
})
export default class StartForm11 extends Vue {

    stepsCompleted = {} as form11StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
